/* VIDA - Quiz interactivo: Inicio > Preguntas > Resultado.
   La logica es independiente del diseno: lee preguntas, opciones y etiquetas del HTML (datos) y puntua cada producto
   por coincidencia de etiquetas. Etiqueta con peso: "objetivo-sueno:2" (sin peso vale 1). No inventa nada. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CONSULT = 'consulta-profesional';
  function T(path, vars, fallback) { return (window.vidaT && window.vidaT(path, vars)) || fallback; }

  function parseTags(str) {
    var out = [];
    (str || '').split(',').forEach(function (raw) {
      var p = raw.trim().toLowerCase(); if (!p) return;
      var w = 1, i = p.lastIndexOf(':');
      if (i > 0 && /^\d+$/.test(p.slice(i + 1))) { w = parseInt(p.slice(i + 1), 10); p = p.slice(0, i); }
      out.push({ tag: p, w: w });
    });
    return out;
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-quiz]:not([data-ready])').forEach(function (quiz) {
      quiz.setAttribute('data-ready', '');
      var intro = quiz.querySelector('[data-intro]');
      var panels = Array.prototype.slice.call(quiz.querySelectorAll('[data-panel]'));
      var result = quiz.querySelector('[data-result]');
      var total = panels.length;
      var top = quiz.querySelector('[data-top]');
      var bar = quiz.querySelector('[data-bar]');
      var fill = quiz.querySelector('[data-bar-fill]');
      var count = quiz.querySelector('[data-count]');
      var back = quiz.querySelector('[data-back]');
      var next = quiz.querySelector('[data-next]');
      var restart = quiz.querySelector('[data-restart]');
      var all = quiz.querySelector('[data-all]');
      var pool = Array.prototype.slice.call(quiz.querySelectorAll('[data-pool] > li'));
      var maxResults = Math.max(1, Math.min(3, parseInt(quiz.getAttribute('data-max'), 10) || 2));
      var step = -1;                 // -1 inicio, 0..total-1 preguntas, total resultado
      var answers = panels.map(function () { return []; });
      var busy = false;

      function el(i) { return i < 0 ? intro : (i >= total ? result : panels[i]); }

      function progress(n) {
        fill.style.transform = 'scaleX(' + (total ? n / total : 0) + ')';
        bar.setAttribute('aria-valuenow', n);
      }

      function swap(from, to, dir) {
        busy = true;
        var d = reduce.matches ? 0 : 340;
        from.classList.remove('is-active');
        from.classList.add(dir > 0 ? 'is-out-left' : 'is-out-right');
        setTimeout(function () {
          from.hidden = true;
          from.classList.remove('is-out-left', 'is-out-right');
          to.hidden = false;
          to.classList.add(dir > 0 ? 'is-in-right' : 'is-in-left');
          requestAnimationFrame(function () { requestAnimationFrame(function () {
            to.classList.remove('is-in-right', 'is-in-left'); to.classList.add('is-active'); busy = false;
            var f = to.querySelector('[data-opt], [data-start]');
            if (f && to !== result) f.focus({ preventScroll: true }); else to.focus({ preventScroll: true });
          }); });
        }, d);
      }

      function updateNav() {
        var onIntro = step < 0, onResult = step >= total;
        top.hidden = onIntro;
        back.hidden = onIntro || onResult;
        var multi = !onIntro && !onResult && panels[step].getAttribute('data-multi') === 'true';
        next.hidden = !multi;
        restart.hidden = !onResult;
        all.hidden = !onResult;
        if (onIntro) { progress(0); }
        else if (onResult) { count.textContent = T('quiz.done', null, 'Listo'); progress(total); }
        else { count.textContent = T('quiz.count', { n: step + 1, total: total }, 'Pregunta ' + (step + 1) + ' de ' + total); progress(step + 1); }
      }

      function go(n, dir) {
        if (busy || n === step) return;
        var from = el(step);
        step = n;
        var to = el(step);
        if (step >= total) showResult();
        swap(from, to, dir);
        updateNav();
        var r = quiz.getBoundingClientRect();
        if (r.top < 0) quiz.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
      }

      // [{label, tags:[{tag,w}]}] de todas las respuestas elegidas
      function chosen() {
        var out = [];
        answers.forEach(function (arr) {
          (arr || []).forEach(function (b) {
            out.push({ label: b.getAttribute('data-label') || '', tags: parseTags(b.getAttribute('data-tags')) });
          });
        });
        return out;
      }

      function showResult() {
        var picks = chosen();
        var consult = picks.some(function (p) { return p.tags.some(function (t) { return t.tag === CONSULT; }); });
        quiz.querySelector('[data-consult]').hidden = !consult;

        var scored = pool.map(function (li) {
          var pt = (li.getAttribute('data-tags') || '').split(',').map(function (s) { return s.trim(); });
          var s = 0, why = [];
          picks.forEach(function (p) {
            var hit = false;
            p.tags.forEach(function (t) { if (t.tag !== CONSULT && pt.indexOf(t.tag) > -1) { s += t.w; hit = true; } });
            if (hit && p.label && why.indexOf(p.label) < 0) why.push(p.label);
          });
          return { li: li, score: s, why: why };
        }).filter(function (x) { return x.score > 0; })
          .sort(function (a, b) { return b.score - a.score; })
          .slice(0, maxResults);

        var grid = quiz.querySelector('[data-result-grid]');
        grid.innerHTML = '';
        scored.forEach(function (x, i) {
          var item = document.createElement('div');
          item.className = 'v-quiz__rec ' + (i === 0 ? 'is-primary' : 'is-secondary');
          var tag = document.createElement('p');
          tag.className = 'v-quiz__reclabel';
          tag.textContent = i === 0 ? 'Tu producto recomendado' : 'También puede interesarte';
          item.appendChild(tag);
          var holder = document.createElement('div');
          holder.innerHTML = x.li.innerHTML;
          holder.querySelectorAll('[data-reveal]').forEach(function (n) { n.classList.add('is-in'); });
          while (holder.firstChild) item.appendChild(holder.firstChild);
          if (x.why.length) {
            var why = document.createElement('p');
            why.className = 'v-quiz__why';
            why.textContent = T('quiz.why', { list: x.why.join(', ') }, 'Coincide con: ' + x.why.join(', '));
            item.querySelector('.v-card__body').insertBefore(why, item.querySelector('.v-card__foot'));
          }
          item.style.setProperty('--d', i * 140);
          grid.appendChild(item);
        });
        grid.setAttribute('data-count', String(scored.length));
        quiz.querySelector('[data-result-empty]').hidden = scored.length > 0;

        var list = quiz.querySelector('[data-summary-list]');
        list.innerHTML = '';
        picks.forEach(function (p) {
          if (!p.label || p.tags.every(function (t) { return t.tag === CONSULT; })) return;
          var li = document.createElement('li'); li.textContent = p.label; list.appendChild(li);
        });
        quiz.querySelector('[data-summary]').hidden = !list.children.length;
        try { sessionStorage.setItem('vida-quiz', JSON.stringify(picks.map(function (p) { return p.label; }))); } catch (e) { /* noop */ }
      }

      function choose(i, opts, o, multi) {
        if (busy) return;
        if (multi) {
          var on = o.getAttribute('aria-checked') !== 'true';
          o.setAttribute('aria-checked', on ? 'true' : 'false'); o.classList.toggle('is-selected', on);
          answers[i] = opts.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; });
        } else {
          opts.forEach(function (b) { b.setAttribute('aria-checked', 'false'); b.classList.remove('is-selected'); });
          o.setAttribute('aria-checked', 'true'); o.classList.add('is-selected');
          answers[i] = [o];
          setTimeout(function () { if (step === i) go(i + 1, 1); }, reduce.matches ? 0 : 340);
        }
      }

      panels.forEach(function (panel, i) {
        var multi = panel.getAttribute('data-multi') === 'true';
        var opts = Array.prototype.slice.call(panel.querySelectorAll('[data-opt]'));
        opts.forEach(function (o, k) {
          o.addEventListener('click', function () { choose(i, opts, o, multi); });
          o.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); opts[(k + 1) % opts.length].focus(); }
            if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); opts[(k - 1 + opts.length) % opts.length].focus(); }
          });
        });
        panel._opts = opts; panel._multi = multi;
      });

      // Teclas 1-9 eligen la opcion de la pregunta activa
      quiz.addEventListener('keydown', function (e) {
        if (step < 0 || step >= total || e.ctrlKey || e.metaKey || e.altKey) return;
        var n = parseInt(e.key, 10);
        var p = panels[step];
        if (n >= 1 && p._opts[n - 1]) { e.preventDefault(); choose(step, p._opts, p._opts[n - 1], p._multi); }
      });

      quiz.querySelector('[data-start]').addEventListener('click', function () { go(0, 1); });
      next.addEventListener('click', function () { go(step + 1, 1); });
      back.addEventListener('click', function () { go(step - 1, -1); });
      restart.addEventListener('click', function () {
        answers = panels.map(function () { return []; });
        panels.forEach(function (p) { p.querySelectorAll('[data-opt]').forEach(function (b) { b.setAttribute('aria-checked', 'false'); b.classList.remove('is-selected'); }); });
        go(-1, -1);
      });

      intro.classList.add('is-active');
      updateNav();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
